import React from 'react';
import ShowPackageCustomCategoryWeightRangeCostsButtonRowProperties from './ShowPackageCustomCategoryWeightRangeCostsButtonRowProperties';
import ViewSmall from '../../../../ui_components/MediaView/ViewSmall';
import ShowPackageCustomCategoryWeightRangeCostsButtonRowSmall from './ShowPackageCustomCategoryWeightRangeCostsButtonRowSmall';
import ViewMedium from '../../../../ui_components/MediaView/ViewMedium';
import ViewLarge from '../../../../ui_components/MediaView/ViewLarge';
import ShowPackageCustomCategoryWeightRangeCostsButtonRowMedium from './ShowPackageCustomCategoryWeightRangeCostsButtonRowMedium';


const ShowPackageCustomCategoryWeightRangeCostsButtonRow: React.FC<ShowPackageCustomCategoryWeightRangeCostsButtonRowProperties> = ({
                                                    customCategoryWeinghtRangesPrice,
                                                }) => {
    return (
        <>
            <ViewSmall>
                <ShowPackageCustomCategoryWeightRangeCostsButtonRowSmall
                    customCategoryWeinghtRangesPrice={customCategoryWeinghtRangesPrice}/>
            </ViewSmall>
            <ViewMedium>
                <ShowPackageCustomCategoryWeightRangeCostsButtonRowMedium
                    customCategoryWeinghtRangesPrice={customCategoryWeinghtRangesPrice}/>
            </ViewMedium>
            <ViewLarge>
                <ShowPackageCustomCategoryWeightRangeCostsButtonRowMedium
                    customCategoryWeinghtRangesPrice={customCategoryWeinghtRangesPrice}/>
            </ViewLarge>
        </>
    )
}

export default ShowPackageCustomCategoryWeightRangeCostsButtonRow;
